// removed by extract-text-webpack-plugin
module.exports = {"cover":"general__cover___GoZi4 backgroundSize-cover backgroundPosition-centerTop position-absolute pinAll"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-card/CardImage/style/general.css
// module id = 132
// module chunks = 0 1